<template>
  <v-container class="cmp-accounting-invoices-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <InvoiceDetails
        :selectedInvoice="selectedInvoice"
        :inv_statTV="inv_statTV"
      />
      <!-- <div
        :style="{ right: tabOptions.length === 1 ? '125px' : '232px' }"
        style="position: absolute; top: 178px"
      >
        <div class="tabs-options--panel" style="display: flex">
          <div class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoiceMailClick()"
              src="static/icons/email/email-grey.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
          <div class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoicePrintClick()"
              src="static/icons/printer.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
          <div v-if="lock_flag == '1'" class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoiceLockClick()"
              src="static/icons/booking/lock-closed.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
          <div
            v-if="lock_flag == 'LOADING'"
            style="width: 26px; height: 26px; padding: 5px"
            class="dt-icon-container loading-icon-container"
          >
            <img
              @click.stop="(e) => onInvoiceLockClick()"
              src="static/icons/loading.gif"
              class="loading-icon"
              alt
            />
          </div>
          <div
            v-if="
              lock_flag == null ||
              lock_flag == '0' ||
              lock_flag == undefined ||
              lock_flag == ''
            "
            class="dt-icon-container"
          >
            <img
              @click.stop="(e) => onInvoiceLockClick()"
              src="static/icons/booking/lock-open.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
        </div>
      </div> -->
      <glayout
        :tabs="invoiceSidewindowTabs"
        :options="tabOptions"
        :loading="selectedInvoice && selectedInvoice.loading"
        @optionClicked="onTabOptionClicked"
      >
        <template #tabPanelRight>
          <div class="tabs-options--panel" style="display: flex">
            <div class="dt-icon-container">
              <img
                v-if="singlePDFDownloadingID > 0"
                src="static/icons/loading.gif"
                alt
                style="height: 10px; width: 10px; margin: 6px 10px"
              />
              <img
                v-else
                @click.stop="(e) => onInvoicePDFClick()"
                src="static/icons/pdf-2.svg"
                class="dt-icon v5 h1 s1"
                alt
                :title="`${$t('pdf')}`"
              />
            </div>
            <div class="dt-icon-container">
              <img
                @click.stop="(e) => onInvoiceMailClick()"
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 h1 s1"
                alt
              />
            </div>
            <div class="dt-icon-container">
              <img
                @click.stop="(e) => onInvoicePrintClick()"
                src="static/icons/printer.svg"
                class="dt-icon v5 h1 s1"
                alt
              />
            </div>
            <div v-if="lock_flag == '1'" class="dt-icon-container">
              <img
                @click.stop="(e) => onInvoiceLockClick()"
                src="static/icons/booking/lock-closed.svg"
                class="dt-icon v5 h1 s1"
                alt
              />
            </div>
            <div
              v-if="lock_flag == 'LOADING'"
              style="width: 26px; height: 26px; padding: 5px"
              class="dt-icon-container loading-icon-container"
            >
              <img
                @click.stop="(e) => onInvoiceLockClick()"
                src="static/icons/loading.gif"
                class="loading-icon"
                alt
              />
            </div>
            <div
              v-if="
                lock_flag == null ||
                lock_flag == '0' ||
                lock_flag == undefined ||
                lock_flag == ''
              "
              class="dt-icon-container"
            >
              <img
                @click.stop="(e) => onInvoiceLockClick()"
                src="static/icons/booking/lock-open.svg"
                class="dt-icon v5 h1 s1"
                alt
              />
            </div>
          </div>
        </template>
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('invoice_contact')" h="260">
                <InvoiceContact
                  :selectedInvoice="selectedInvoice"
                  @vat_update="onInvoiceVatUpdate"
                  @changed="onInvoiceChange"
                />
              </gbox>
              <gbox :title="$t('invoice_document')" h="253">
                <InvoiceDocument
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceChange"
                />
              </gbox>
              <gbox :title="$t('deal_memo_internal')" bc="var(--bc-note)">
                <DBoxTextarea
                  :disabled="selectedInvoice.disabled"
                  :value="
                    selectedInvoice.invoice.notes ||
                    selectedInvoice.internal_notes
                  "
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
              <gbox v-if="isRoyaltyAccountInvoice" :title="$t('royalty_dates')">
                <RoyaltyDates
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceChange"
                  @perform_click="onPerformClick"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('mandatory_infos')" h="352">
                <MandatoryInfo
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceChange"
                />
              </gbox>
              <gbox :title="$t('vat')" :h="vatHeight">
                <Vats
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceChange"
                  @change_tax_deduc="onInvoiceTaxDeduc"
                />
              </gbox>
              <gbox :title="$t('payment_terms')" h="259">
                <PaymentTerms
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="invoice_lines">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedInvoice &&
                      selectedInvoice.invoicelines &&
                      selectedInvoice.invoicelines.length
                  )
                "
                :title="$t('invoice_lines')"
              >
                <InvoiceLines
                  :selectedInvoice="selectedInvoice"
                  @changed="onInvoiceLineChange"
                  @invoiceline_added="onInvoiceLineAdded"
                  @invoiceline_deleted="onInvoiceLineDeleted"
                  @invoice_change="onInvoiceChange"
                  @change_tax_deduc="onInvoiceTaxDeduc"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="payments">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedInvoice &&
                      selectedInvoice.payments &&
                      selectedInvoice.payments.length
                  )
                "
                :title="$t('payments')"
              >
                <Payments
                  :selectedInvoice="selectedInvoice"
                  @changed="onPaymentChange"
                  @deleted="onPaymentDelete"
                  @currency_changed="onPaymentCurrencyChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="forwarding">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedInvoice &&
                      selectedInvoice.artist_payments &&
                      selectedInvoice.artist_payments.length,
                    NTOffsets.WithHeaderDBoxBottom + 32
                  )
                "
                :title="$t('artist_payments')"
              >
                <ForwardArtistPayments
                  :selectedInvoice="selectedInvoice"
                  @changed="onArtistPaymentsChange"
                  @changeInvoice="onInvoiceChangeFromArtistPayments"
                  @invoiceline_added="onArtistPaymentsAdded"
                  @artistpayments_deleted="onArtistPaymentsDeleted"
                  @invoice_change="onInvoiceChange"
                  @change_tax_deduc="onInvoiceTaxDeduc"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <ModalContainer :modalKey="'assignInvoiceContact'" :width="'medium'">
      <AssignInvoiceContact
        :selectedInvoice="selectedInvoice"
        @done="onAssignContactDone"
        @cancelled="onassignInvoiceContactCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'vatTerritoryModal'" :width="'600'">
      <VatTerritoryModal
        :selectedInvoice="selectedInvoice"
        @done="onVatTerritoryChange"
        @cancelled="onassignInvoiceContactCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'performModal'" :width="'medium'">
      <PerformModal
        :royaltyStatmentList="royaltyStatmentList"
        @cancelled="onassignInvoiceContactCancelled"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { AccountingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import BoxWidget from "@plugins/box-widget/box-widget";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import InvoiceDetails from "./invoice-details";
import MandatoryInfo from "./mandatory-info";
import InvoiceContact from "./invoice-contact";
import InvoiceDocument from "./invoice-document";
import RoyaltyDates from "./royalty-dates";
import PaymentTerms from "./payment-terms";
import InvoiceTotals from "./invoice-totals";
import InvoiceLines from "./invoice-lines";
import VatTerritoryModal from "./vat-territory-modal.vue";
import Payments from "./payments";
import ForwardPayments from "./forward-payments";
import Vats from "./vats";
import PerformModal from "./perform-modal";

import AssignInvoiceContact from "./assign-invoice-contact";

import {
  encodeRoute,
  openWindow,
  decode,
  downloadPDF,
} from "../../../../utility";
import { bookingListCalendarDateTabRoute } from "../../../booking/router/router";
import { HttpClient } from "../../../../services/http/http-client";
import { sendInvoiceMail } from "./invoice-list.vue";
import { invoiceListLDTRoutes } from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { invoiceGetters } from "../../store/invoices/getters";
import { tv } from "../../../../models/text-value.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createLanguageTV } from "../../../../models/language.model";
import { createUserTV } from "../../../../models/user.model";
import { invoiceActions } from "../../store/invoices/actions";
import { pathOr } from "ramda";
// import InvoiceLinesForward from "./invoice-forward-line"
import ForwardArtistPayments from "./invoice-forward-payment";
// console.log(invoiceDetailsGrid);
import { InvoiceForwardService } from "../../services/invoice-forward.service";
import { distributionOrderListLDTRoutes } from "../../../distribution/router/routes";
export const moduleRoute = "accounting";
export const submenuRoute = "invoices";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,

    // Sidewindow,
    // InvoiceLinesForward,

    InvoiceDetails,
    MandatoryInfo,
    InvoiceContact,
    InvoiceDocument,
    RoyaltyDates,
    PaymentTerms,
    InvoiceTotals,
    InvoiceLines,
    Payments,
    ForwardPayments,
    Vats,
    ForwardArtistPayments,
    ModalContainer,
    AssignInvoiceContact,
    VatTerritoryModal,
    PerformModal,
  },
  data: function () {
    return {
      active: -1,
      lockLoading: false,
      royaltyStatmentList: [],
      singlePDFDownloadingID: 0,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("assignInvoiceContact"),
    createModalMixin("vatTerritoryModal"),
    createModalMixin("performModal"),
  ],
  mounted: function () {
    // this.routeMount();
    // console.log(this.$refs['cmp-invoice-sidewindow']);
    // this.$refs['cmp-invoice-sidewindow'].focus();
    // document.addEventListener('keyup', event => {
    //   console.log(event);
    // })
    // console.log("SEL INVOICES",this.selectedInvoice)
  },
  watch: {},
  computed: {
    // ...mapGetters(storeNS, {
    //   selectedInvoice: "selectedInvoice",
    //   InvoiceDetailsGrid: "InvoiceDetailsGrid",
    //   accountingInfo: "accountingInfo",
    //   vatRatesTV: "vatRatesTV"
    // }),
    ...mapGetterObject(storeNS, invoiceGetters),
    selectedInvoice: function () {
      console.log("SEL INVOICES", this.invoice);
      return this.invoice;
    },
    selectedInvoiceId: function () {
      return this.selectedInvoice?.invoice?.invoice_id;
    },
    vatHeight: function () {
      return this.selectedInvoice?.invoice?.vat_handling == 1 ||
        this.selectedInvoice?.invoice?.vat_handling == 2
        ? 164
        : 132;
    },
    calendarDateId: function () {
      return pathOr(
        undefined,
        ["cdate", "calendar_date_id"],
        this.selectedInvoice
      );
    },
    contact_relation_table: function () {
      return this.selectedInvoice.contact.getExternalTable();
    },
    invoiceSidewindowTabs: function () {
      return checkTabListPermission(
        moduleRoute,
        submenuRoute,
        this.$store.getters.account.client.settings_show_money_forwarding ===
          "1"
          ? [
              {
                route: "overview",
                value: this.$t("tab_title_invoice_info"),
              },
              {
                route: "invoice_lines",
                value: this.$t("invoice_lines"),
              },
              {
                route: "payments",
                value: this.$t("payments"),
              },
              {
                route: "forwarding",
                value: this.$t("tab_title_forwarding"),
              },
            ]
          : [
              {
                route: "overview",
                value: this.$t("tab_title_invoice_info"),
              },
              {
                route: "invoice_lines",
                value: this.$t("invoice_lines"),
              },
              {
                route: "payments",
                value: this.$t("payments"),
              },
            ]
      );
    },
    invoiceObj: function () {
      return pathOr(undefined, ["invoice"], this.selectedInvoice);
    },
    lock_flag: function () {
      return pathOr("", ["invoice", "lock_flag"], this.selectedInvoice);
    },
    status_color: function () {
      return pathOr("", ["invoice", "status_color"], this.selectedInvoice);
    },
    show_royalty_dates: function () {
      const fromQuery = decode(this.$route?.query?.from || "");
      console.log("Log: fromQuery", fromQuery, this.gdi("royalty_dates"));
      let show_rd = false;
      if (fromQuery.name && fromQuery.name == bookingListCalendarDateTabRoute) {
        show_rd = false;

        //TODO: Make this automatic. For now the Automatic relocation of grid in case a box is not visible - Is not working
        if (this.gdi("trailing_text")) {
          this.gdi("trailing_text").y = 5; //this.gdi('royalty_dates').y ;
        }
      }

      return this.gdi("royalty_dates") && show_rd;
    },

    // TABULATION REFACTORING
    invoice_id: function () {
      return this.$route.params.invoice_id;
    },
    invoice: function () {
      const selectedInvoice = this["invoiceDetails"][this.invoice_id] || {};

      console.log("THIS IS SELECTED", selectedInvoice);

      const invoice = selectedInvoice?.invoice || {};
      const status_color = selectedInvoice?.invoice?.status_color || "";

      const lock_flag = invoice.lock_flag || false;
      const disabled = lock_flag == 1 ? true : false;

      const currencies = selectedInvoice?.currencies || [];
      const invoiceCurrencyId = invoice.currency_id || "";
      const invoiceCurrency =
        currencies.find((e) => {
          if (invoiceCurrencyId != "") {
            return e.currency_id == invoiceCurrencyId;
          } else {
            return e.currency_iso == invoice?.client_currency_iso;
          }
        }) || {};

      const invoice_projects = selectedInvoice?.invoice_projects || [];
      const invoice_projectsTV = invoice_projects.map(
        tv("invoice_project_name", "invoice_project_id")
      );

      const currenciesTV = createCurrencyTV(currencies);

      const users = selectedInvoice?.users || [];
      const usersTV = createUserTV(users);

      const languages = selectedInvoice?.languages || [];
      const languagesTV = createLanguageTV(languages);

      const contact = selectedInvoice?.contact || {};

      const payment_methods = selectedInvoice?.payment_methods || [];
      const payment_methodsTV = payment_methods.map(
        tv("payment_method_name", "payment_method_id")
      );

      const money_accounts = selectedInvoice?.money_accounts || [];
      const money_accountsTV = money_accounts.map(
        tv("money_account_name", "money_account_id")
      );
      const calendar_date_artistsTV =
        selectedInvoice?.calendar_date_artists?.map((v) => {
          return { text: v.artist_name, value: v.artist_name };
        }) || [];
      const tax_deductions = selectedInvoice?.tax_deductions || [];
      const tax_deductionsTV = tax_deductions.map(
        tv("tax_group_name", "tax_group_id")
      );
      const selectedTaxDeduction = (
        tax_deductionsTV.find(
          (c) => c.value == invoice.tax_type_id_deduction
        ) || {}
      ).text;

      const invoicelines = selectedInvoice?.invoicelines || [];

      let artist_payments = selectedInvoice?.artist_payments || [];
      const agent_payments = selectedInvoice?.agent_payments || [];
      artist_payments = artist_payments.map((a) => {
        a.amountEUR = a.amount * a.exchangerate;
        return a;
      });
      const vatRatesTV = [
        { value: 1, text: invoice?.vat_rate1 ?? "0.00" },
        { value: 2, text: invoice?.vat_rate2 ?? "0.00" },
        { value: 3, text: invoice?.vat_rate3 ?? "0.00" },
      ];
      const invoiceBackground =
        {
          "#07f300": "64C896",
          "#fffe00": "E6DC64",
          "#0000ff": "86C0F4",
          "#fd5b2c": "FA8237",
          "#ca0005": "FF6E6E",
          "#666666": "C8C8C8",
          "#000000": "505050",
        }[status_color] || "jordyblue";

      return {
        ...selectedInvoice,
        invoice,
        contact,
        lock_flag,
        disabled,
        invoiceCurrency,
        invoice_projects,
        invoice_projectsTV,
        currencies,
        currenciesTV,
        users,
        usersTV,
        languages,
        languagesTV,
        payment_methods,
        payment_methodsTV,
        money_accounts,
        money_accountsTV,
        tax_deductions,
        tax_deductionsTV,
        selectedTaxDeduction,
        invoicelines,
        artist_payments,
        agent_payments,
        calendar_date_artistsTV,
        invoice_id: this.invoice_id,
        vatRatesTV,
        invoiceBackground,
      };
    },

    tabOptions() {
      return [
        {
          text: this.$t("change_status"),
          value: "change_status",
        },
        ...(this.invoice?.go_to_booking
          ? [
              {
                text: this.$t("go_to_booking"),
                value: "go_to_booking",
              },
            ]
          : []),
        ...(this.invoice?.l_order
          ? [
              {
                text: this.$t("go_to_order"),
                value: "go_to_order",
              },
            ]
          : []),
      ];
    },
    isRoyaltyAccountInvoice() {
      return this.selectedInvoice?.invoice?.external_table == "accounts";
    },
  },
  methods: {
    ...mapActionObject(storeNS, invoiceActions),
    onPerformClick: function (payload) {
      console.log(payload, "::::::::::::::::");
      this.royaltyStatmentList = payload;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "perform_modal",
        },
      });
    },
    closeInvoiceDetails: function (value) {
      this.$emit("closeInvoiceDetails", value);
    },
    onInvoiceChange: function (payload) {
      console.log("INVOICE PAYLOAD", payload);
      this[ActionTypes.InvoiceDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.invoice,
      });
    },
    onVatTerritoryChange: function (payload) {
      console.log(";;;;invoice", this.invoice);
      this[ActionTypes.InvoiceDetails.UPDATE.SINGLE]({
        name: "vat_territory",
        value: payload.vat_territory,
        data: payload,
        item: this.invoice,
      });
      this.onassignInvoiceContactCancelled();
    },
    onInvoiceTaxDeduc: function ({ name, value }) {
      this[ActionTypes.CHANGE_TAX_DEDUC]({
        item: this.invoice,
        invoice_id: this.invoiceObj.invoice_id,
        vat_handling: this.invoiceObj.vat_handling,
        tax_type_id_deduction:
          name == "vat_handling" ? null : this.invoiceObj.tax_type_id_deduction,
        [name]: value,
      });
    },
    onInvoiceVatUpdate: function (payload) {
      this[ActionTypes.UPDATE_VAT_NO]({
        ...payload,
        contact_id: this.invoiceObj.contact_id,
        item: this.invoice,
      });
    },

    onNotesBlur: function (event) {
      this.onInvoiceChange({
        name: "notes",
        value: event.target.value,
      });
    },
    onSubjectBlur: function () {
      this.onInvoiceChange({
        name: "subject",
        value: event.target.value,
      });
    },
    onInvoiceTextboxBlur: function (name, value) {
      this.onInvoiceChange({
        name,
        value,
      });
    },
    onRefreshClick: function () {
      this[ActionTypes.InvoiceDetails.FETCH.SINGLE]({
        flag: true,
        invoice: this.selectedInvoice.invoice,
        reload: true,
      });
    },
    onInvoicePDFClick: async function () {
      if (this.singlePDFDownloadingID > 0) {
        return;
      }

      const { invoice_id, invoice_ref } = this.selectedInvoice.invoice;
      this.singlePDFDownloadingID = invoice_id;

      const filename = `${invoice_ref}.pdf`;
      const printURL = `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`;

      await downloadPDF(printURL, this.$store.getters.account, filename);
      this.singlePDFDownloadingID = 0;
    },

    onTabOptionClicked(value) {
      console.log("value", value);
      switch (value) {
        case "change_status":
          this.onInvoiceEditClick();
          console.log("kdjsl");
          break;
        case "go_to_booking":
          this.onGotoBookingClick();
          break;
        case "go_to_order":
          this.onGotoOrderClick();
          break;
        default:
          break;
      }
    },

    onInvoiceMailClick: async function () {
      console.log(
        "Log: this.selectedInvoice.invoice",
        this.selectedInvoice.invoice
      );
      await sendInvoiceMail(this.selectedInvoice.invoice);
    },
    onInvoicePrintClick: async function () {
      const { invoice_id } = this.selectedInvoice.invoice;
      await this.onInvoiceLockClick();
      if (invoice_id) {
        openWindow(
          `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`,
          "Print Invoice",
          { wr: 0.7, hr: 0.7 }
        );
      }
    },
    onInvoiceEditClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "set_status",
          invoice_id: this.selectedInvoiceId,
        },
      });
    },
    onInvoiceLockClick: function () {
      this[ActionTypes.LOCK_INVOICE]({
        from: "details",
        item: this.selectedInvoice,
      });
    },
    onGotoBookingClick: function () {
      if (this.calendarDateId) {
        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: {
            calendar_date_id: this.calendarDateId,
            tab: "overview",
          },
          query: {
            from: encodeRoute(this.$route),
          },
        });
      }
    },
    onGotoOrderClick: function () {
      const order_id = this.invoice.l_order?.order_id;
      console.log({
        "invoice-sidewindow.vue:637 distributionOrderListLDTRoutes":
          distributionOrderListLDTRoutes,
      });

      if (order_id) {
        this.$router.push({
          name: distributionOrderListLDTRoutes.names.tab,
          params: {
            order_id: order_id,
            tab: "overview",
          },
          query: {
            from: encodeRoute(this.$route),
          },
        });
      }
    },
    onInvoiceLineChange: function (payload) {
      console.log({ onInvoiceLineChange: payload });
      this[ActionTypes.InvoiceLines.UPDATE.SINGLE]({
        ...payload,
        invoice: this.invoice,
      });
    },
    updatePayment: function (payload) {
      this[ActionTypes.Payments.UPDATE.SINGLE]({
        ...payload,
        invoice: this.invoice,
      });
    },
    onPaymentChange: function (payload) {
      this.updatePayment(payload);
    },
    onPaymentDelete: function (item) {
      this[ActionTypes.Payments.DELETE.SINGLE]({
        invoice: this.invoice,
        item,
      });
    },
    onPaymentCurrencyChange: function (payload) {
      this.updatePayment(payload);
    },
    onSidwindowKeyUp: function (event) {
      console.log(event);
    },

    onInvoiceLineAdded: function () {
      this[ActionTypes.InvoiceLines.INSERT.SINGLE]({
        invoice: this.invoice,
      });
    },
    onInvoiceLineDeleted: function (item) {
      this[ActionTypes.InvoiceLines.DELETE.SINGLE]({
        ...item,
        invoice: this.invoice,
      });
    },
    onassignInvoiceContactCancelled: function () {
      this.$router.push({
        query: {
          modal: undefined,
        },
      });
    },
    onAssignContactDone: function () {
      this.onassignInvoiceContactCancelled();
      this.onRefreshClick();
    },

    //FORWARD ACCOUNTS

    onArtistPaymentsAdded: function () {
      const payload = this.invoice;
      this[ActionTypes.ArtistPayments.INSERT.SINGLE]({ item: payload });
    },
    onArtistPaymentsChange: function ({ name, value, item }) {
      const payload = {
        name: name,
        value: value,
        artist: item,
        item: this.invoice,
      };

      this[ActionTypes.ArtistPayments.UPDATE.SINGLE](payload);
    },

    onArtistPaymentsDeleted: function (payload) {
      this[ActionTypes.ArtistPayments.DELETE.SINGLE]({
        item: this.invoice,
        ...payload,
      });
    },

    onInvoiceChangeFromArtistPayments: function (payload) {
      this[ActionTypes.InvoiceDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.invoice,
      });
    },

    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 200px);
  }
  // .overview-options {
  //   margin-top: 7%;
  //   .icons {
  //     display: flex;
  //     justify-content: center;
  //     img:first-child {
  //       padding-top: 2px;
  //     }
  //     img {
  //       cursor: pointer;
  //     }
  //     .loading-icon-container {
  //       width: 30px;
  //       .loading-icon {
  //         width: 15px;
  //         height: 15px;
  //         padding-left: 5px;
  //       }
  //     }

  //     .status {
  //       margin-top: 17px;
  //       margin-left: 5px;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
  //         border-radius: 30px;
  //       }
  //     }
  //   }
  // }
}
</style>
